import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    loading: _ctx.loading == 'loading',
    columns: _ctx.fields,
    data: _ctx.items.data,
    pagination: _ctx.items,
    "scroll-options": { x: 1500 },
    showCreateButton: false,
    onFilter: _ctx.filterRecord
  }, null, 8, ["loading", "columns", "data", "pagination", "onFilter"]))
}